import React from 'react';
import Header from '../Header/Header';
import Banner from '../Banner/Banner';
import Services from '../Services/Services';
import Statistics from '../Statistics/Statistics';
import Testimonials from '../Testimonials/Testimonials';
import Partners from '../Partners/Partners';
import BlogSection from '../Blog/BlogSection';
// import Blog from '../Blog/Blog';  
// import Contact from '../Contact/Contact';
import Faq from '../Faq/Faq';
import Footer from '../Footer/Footer';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Header />
      <Banner />
      <Services />
      <Statistics />
      <Testimonials />
       <Partners />
       <BlogSection />
      <Faq /> 
      {/* <Contact /> */}
      <Footer />
    </div>
  );
};

export default Home;